import { render } from "./SurveyBuilderReview.vue?vue&type=template&id=056e76dd&scoped=true"
import script from "./SurveyBuilderReview.vue?vue&type=script&lang=js"
export * from "./SurveyBuilderReview.vue?vue&type=script&lang=js"

import "./SurveyBuilderReview.vue?vue&type=style&index=0&id=056e76dd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056e76dd"]])

export default __exports__